import { createTheme } from '@mui/material/styles';
import variables from '~/components/common/globalStyles/_variables.module.scss';
import { CheckboxCheckedIcon, CheckboxIcon } from './assets/icons';

export const appTheme = createTheme({
  typography: {
    fontFamily: variables.font,
    fontSize: 14,
    button: {
      textTransform: 'none',
      fontSize: 14,
    },
  },
  palette: {
    primary: {
      light: variables.colorPrimary,
      main: variables.colorPrimary,
      dark: variables.colorPrimary,
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: variables.colorSecondary,
      main: variables.colorSecondary,
      dark: variables.colorSecondary,
      contrastText: '#758CA5',
    },
    info: {
      light: variables.colorInfo,
      main: variables.colorInfo,
      dark: variables.colorInfo,
      contrastText: '#FFFFFF',
    },
    error: {
      light: variables.colorError,
      main: variables.colorError,
      dark: variables.colorError,
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: { shrink: true, variant: 'outlined' },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckboxIcon className='w-[17px] h-[17px]' />,
        checkedIcon: <CheckboxCheckedIcon className='w-[17px] h-[17px]' />,
      },
    },
  },
});
